import { ifAuthenticated } from "@/router";

export default [
  {
    path: "/effectiveRate",
    name: "effectiveRateIndex",
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "effective-rate" */ "@/views/reporting/EffectiveRate.vue")
  },
  {
    path: "/auditApproval",
    name: "auditApprovalIndex",
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "audit-approval" */ "@/views/reporting/AuditApproval.vue")
  }
];
